import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';
import { type Registry as Services, service } from '@ember/service';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import ActionBookingsRepliesReplyController from 'uplisting-frontend/pods/action/bookings/replies/reply/controller';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';
import { getParentRouteRecordKey } from 'uplisting-frontend/utils/rhs/helpers';

interface IParams extends Record<string, unknown> {
  reply_id: string;
}

export default abstract class SidebarBookingsRepliesReplyRoute extends BaseRoute {
  @service('repositories/saved-reply')
  savedReplyRepository!: Services['repositories/saved-reply'];

  abstract parentRoute: string;

  model(params: IParams) {
    const record = this.modelFor(this.parentRoute) as RhsRecord;

    return hash({
      [getParentRouteRecordKey(this.parentRoute)]: record,
      property: record.property.reload(),
      savedReply: this.savedReplyRepository.findRecord(params.reply_id, {
        include: 'custom-message-tags',
      }),
    });
  }

  setupController(
    controller: ActionBookingsRepliesReplyController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);
  }
}
